/* @flow */
import * as React from 'react';

const Calendar = props => (
  <svg
    width={30}
    height={29}
    viewBox="0 0 30 29"
    stroke="none"
    strokeWidth={1}
    fill="#FFF055"
    fillRule="evenodd"
    {...props}>
    <path d="M8,0 C7.448,0 7,0.448 7,1 L7,4 L2,4 C0.897,4 0,4.897 0,6 L0,26 C0,27.654 1.346,29 3,29 L27,29 C28.654,29 30,27.654 30,26 L30,6 C30,4.897 29.103,4 28,4 L23,4 L23,1 C23,0.448 22.552,0 22,0 C21.448,0 21,0.448 21,1 L21,4 L9,4 L9,1 C9,0.448 8.552,0 8,0 Z M27,27 L3,27 C2.449,27 2,26.551 2,26 L2,11 L28,11 L28,26 C28,26.551 27.551,27 27,27 Z M21,6 L21,7 C21,7.552 21.448,8 22,8 C22.552,8 23,7.552 23,7 L23,6 L28,6 L28,10 L2,10 L2,6 L7,6 L7,7 C7,7.552 7.448,8 8,8 C8.552,8 9,7.552 9,7 L9,6 L21,6 Z" />
    <path d="M10,13 C9.448,13 9,13.448 9,14 L9,24 C9,24.552 9.448,25 10,25 C10.552,25 11,24.552 11,24 L11,14 C11,13.448 10.552,13 10,13 Z" />
    <path d="M20,20 L19,20 L19,14 C19,13.565 18.719,13.18 18.305,13.048 C17.89,12.917 17.439,13.065 17.186,13.419 L12.186,20.419 C11.969,20.724 11.939,21.125 12.111,21.458 C12.283,21.791 12.625,22 13,22 L17,22 L17,24 C17,24.552 17.448,25 18,25 C18.552,25 19,24.552 19,24 L19,22 L20,22 C20.552,22 21,21.552 21,21 C21,20.448 20.552,20 20,20 Z M17,20 L14.943,20 L17,17.121 L17,20 Z" />
  </svg>
);

export default Calendar;



// WEBPACK FOOTER //
// ./src/assets/images/icons/calendar.js